import { render, staticRenderFns } from "./TheSubscriptions.vue?vue&type=template&id=34837fbf&"
import script from "./TheSubscriptions.vue?vue&type=script&lang=ts&"
export * from "./TheSubscriptions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34837fbf')) {
      api.createRecord('34837fbf', component.options)
    } else {
      api.reload('34837fbf', component.options)
    }
    module.hot.accept("./TheSubscriptions.vue?vue&type=template&id=34837fbf&", function () {
      api.rerender('34837fbf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/TheSubscriptions.vue"
export default component.exports